<template>
  <base-content>
    <template v-slot:top>
      <HeroHeader heading="KYC and anti-money laundering checks"/>
    </template>

    <template v-if="isOnboardPending || pending">
      <base-loader>
        Please wait a moment whilst we attempt to automatically conduct our mandatory KYC and AML checks.
        If we require any further information, we will ask for this in your dashboard.
      </base-loader>
    </template>
    <template v-else>
      <template v-if="errorOnOnboard">
        <div class="lead text-center">
          {{ errorOnOnboard }}
        </div>
      </template>
    </template>

    <template v-slot:bottom>
      <div class="bg-light py-4">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-sm-6">
              Estimated time to complete: <strong>2 minutes</strong>
            </div>
            <div class="col-sm-6 text-right">
              <base-button :disabled="pending" icon-right="arrow-right" primary :to="{ name: 'account.confirmation', params: { id: account._id } }">
                Continue
              </base-button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </base-content>
</template>

<script>
import { mapState } from 'vuex'

import HeroHeader from '@/components/HeroHeader.vue'

export default {
  created () {
    this.account = this.$auth.user.accounts.find(account => account._id === this.$route.params.id)

    if (!this.$auth.user.profile.verifications.amlTaken) {
      this.onboard()
    }
  },

  data: () => ({
    account: {},
    onboarded: false,
    pending: true
  }),

  components: {
    HeroHeader
  },

  computed: {
    ...mapState({
      errorOnOnboard: store => store.core.auth.errorOnOnboard,
      isOnboardPending: store => store.core.auth.isOnboardPending
    })
  },

  methods: {
    async onboard () {
      await this.$store.dispatch('core/auth/onboard', this.account._id)

      if (!this.errorOnOnboard) {
        await this.$store.dispatch('core/auth/refresh')

        this.onboarded = true
      }

      this.pending = false
    }
  }
}
</script>
